
import { Component, Vue } from 'vue-property-decorator'
import { ReporterService } from '@/services/index'

@Component({
    components: {
    }
})
export default class extends Vue {
    private toDeletedList = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = true 
    private statusOption: string = 'all'
    private statusOptions = [
        { key: 'all', value: '全部', index: 0 },
        { key: 'unResolved', value: '未解决', index: 1 },
        { key: 'deleted', value: '已删除', index: 2 },
        { key: 'noDelete', value: '不用删', index: 3 }
    ]
    private statusMap: any = {
        'all': 0,
        'unResolved': 1,
        'deleted': 2,
        'noDelete': 3
    }

    private mounted() {
        this.getToDeletedList()
    }

    private async getToDeletedList() {
        const params = { 
            status: this.statusMap[this.statusOption], 
            page_index: this.pageIndex, 
            page_size: this.pageSize 
        }
        const result = await ReporterService.getToDeletedList(params)
        if (result.status === 200) {
            this.toDeletedList = result.data.results
            this.pageTotal = result.data.page_total
        }
        this.loading = false
    }

    private statusValueMap(status: number) {
        for (let index in this.statusOptions) {
            if (this.statusOptions[index].index === status) {
                return this.statusOptions[index].value
            }
        }
    }

    private onStatusOptionChange() {
        this.pageIndex = 1
        this.getToDeletedList()
    }

    private onDelete(id: number) {
        this.$confirm('是否确认删除这个记者？请谨慎操作', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const params = { id, operate: this.statusMap.deleted }
            const result = await ReporterService.updateToDeletedStatus(params)
            if (result.status === 200) {
                this.$message({
                    type: 'success',
                    message: '更新成功'
                })
                this.getToDeletedList()
            } else {
                this.$message.error(result.message)
            }
        }).catch(() => {})
    }

    private onNoDelete(id: number) {
        this.$confirm('是否确认这个记者不必删除？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const params = { id, operate: this.statusMap.noDelete }
            const result = await ReporterService.updateToDeletedStatus(params)
            if (result.status === 200) {
                this.$message({
                    type: 'success',
                    message: '更新成功'
                })
                this.getToDeletedList()
            } else {
                this.$message.error(result.message)
            }
        }).catch(() => {})
    }

    private onRecover(id: number) {
        this.$confirm('是否确认之前删错了，要恢复这个被删除的记者？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const params = { id, operate: this.statusMap.unResolved }
            const result = await ReporterService.updateToDeletedStatus(params)
            if (result.status === 200) {
                this.$message({
                    type: 'success',
                    message: '更新成功'
                })
                this.getToDeletedList()
            } else {
                this.$message.error(result.message)
            }
        }).catch(() => {})
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getToDeletedList()
        $backtop.scrollToTop()
    }
}
